<template>
  <div style="background-color: #F5F7FA;height: 100%;">
    <div style="padding: 0px;position: relative;">
      <template>
        <el-table  :data="tableData" :height="230" border>
          <el-table-column prop="idcard" label="身份证号"></el-table-column>
          <el-table-column prop="cholesterin" label="总胆固醇"></el-table-column>
          <el-table-column prop="createTime" label="时间" :formatter="timefilter"></el-table-column>

        </el-table>
        <div style="text-align: left;background-color: #fff;padding: 10px;">
          <div style="float: left;padding: 5px;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
          <div style="float: left;">
            <el-pagination
                background
                layout="prev, pager, next"
                :total="totalItems"
                :page-size="20"
                :current-page.sync="currentPage"  @current-change="current_change">
            </el-pagination>
          </div>
          <div style="clear: both;"></div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>

import {timefilters} from "@/common/times";

export default {
  name: "BloodPressureAndHeartRate",
  data() {
    return {

      arr:[],

      tableData:null,
      totalItems: 0,
      pageSize:20,
      currentPage:1,
    }
  },
  components: {

  },

  methods: {
    init(result) {
      this.arr = result.custCholDtos;

      let arr2 = [];
      let start = (this.currentPage-1)*this.pageSize;
      let end = start + this.pageSize;
      for(let i=0;i<this.arr.length;i++){
        if(i>=start && i<end){
          arr2.push(this.arr[i]);
        }
      }
      this.tableData = arr2;
      this.totalItems = this.arr.length;
    },

    current_change:function(currentPage){
      this.currentPage = currentPage;

      let arr2 = [];
      let start = (this.currentPage-1)*this.pageSize;
      let end = start + this.pageSize;
      for(let i=0;i<this.arr.length;i++){
        if(i>=start && i<end){
          arr2.push(this.arr[i]);
        }
      }
      this.tableData = arr2;
      this.totalItems = this.arr.length;

    },

    //日期格式
    timefilter(row, column, cellValue) {
      return timefilters(cellValue);
    },

  }


}
</script>
